import { AccessPermission, AuthenticationState, UserType } from '../constants';

export interface ILoginCredentials {
  username: string;
  password: string;
  rememberLogin: boolean;
  returnUrl: string;
  clientType?: string;
}

export interface IAuthCodeModel {
  selectedContactId: number;
  regenerateCode: boolean;
  timeoutHours: number;
  clientType: string;
}

export interface IProfile {
  username: string;
  accountCode: string;
  erauReference: string;
  state: AuthenticationState;
  selectedAccount: IAccountDetails;
  user: IUserDetails;
}

export interface IUserDetails {
  id: string;
  name: string;
  username: string;
  email: string;
  isLocked: boolean;
  isActivated: boolean;
  accountDisabled: boolean;
  isSuperUser: boolean;
  mfaConfigured: boolean;
  mfaDisabled: boolean;
  mfaOptional: boolean;
  accounts: Array<IAccountDetails>;
}

export interface IAccountDetails {
  contactId: number;
  accountName: string;
  accountCode: string;
  accountPermissions: number;
  termsAndConditionsAccepted: boolean;
  providerType: number;
  providerTypeString: string;
  createdDate: string;
  activationDate: string;
  loginHistory: Array<string>;
  roleId: number;
}

export interface IMfaSetupResponse {
  authenticatorKey: string;
  configured: boolean;
  qrCodeString: string;
}

export interface IMfaConfirmResponse {
  confirmed: boolean;
  message: string;
}

export enum SecurityEvents {
  userSignedIn,
  userLoaded,
  accountVerified,
  badCredentials,
  userSignedOut,
  sourceApplicationChanged,
}

export interface ISecurityEvent {
  eventType: SecurityEvents;
  payload: any;
}

export interface IRequestResetPasswordModel {
  email: string;
  clientType: string;
}

export interface IRequestResetMfaModel {
  email: string;
}

export interface IResetPasswordModel {
  token: string;
  newPassword: string;
}

export interface INewAccountModel {
  email: string;
  firstName: string;
  lastName: string;
  accounts: Array<string>;
  clientType: string;
}

export interface IResetPasswordResponseModel {
  isAccountActivation: boolean;
  success: boolean;
  accountLocked: boolean;
  tokenMismatch: boolean;
  invalidAccount: boolean;
}

export interface IUser {
  name: string;
  emailAddress: string;
  userType: UserType;
  associatedAccounts: IAccount[];
  selectedAccount: IAccount;
  permissions: IAccessPermission;
}

export interface IAccount {
  code: string;
  isFirstLogon: boolean;
  contactId: number;
  accountName: string;
}

export interface IAccessPermission {
  id: AccessPermission;
  title: string;
  description: string;
  granted: boolean;
}

export interface IApplicationProfile {
  applicationName: string;
  showSignUpButton: boolean;
  showTermsAndConditions: boolean;
}